import { render, staticRenderFns } from "./address-step.vue?vue&type=template&id=2f88f16c&"
import script from "./address-step.vue?vue&type=script&lang=js&"
export * from "./address-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports